module.exports = __webpack_public_path__ + "static/media/yt.95c61f43.svg";